export default "__VITE_ASSET__CazNByss__"